import { useState, useEffect } from 'react';
import { collection, onSnapshot, QuerySnapshot, DocumentData } from 'firebase/firestore';
import { db } from '../firebase/config';
import { FoedselsDag } from '../types';

interface UseFoedselsDageResult {
  foedselsDage: FoedselsDag[];
  loading: boolean;
  error: string | null;
}

export function useFoedselsDage(): UseFoedselsDageResult {
  const [foedselsDage, setFoedselsDage] = useState<FoedselsDag[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const ref = collection(db, 'foedselsDage');
    const unsubscribe = onSnapshot(
      ref,
      (snapshot: QuerySnapshot<DocumentData>) => {
        const data: FoedselsDag[] = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as FoedselsDag[];
        setFoedselsDage(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Fejl ved hentning af fødselsdage:', err);
        setError('Kunne ikke hente fødselsdage. Prøv igen senere.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { foedselsDage, loading, error };
}
